import Helper from '@ember/component/helper';
import Model from '@ember-data/model';
import { type Registry as Services, service } from '@ember/service';

interface CanSignature {
  Args: {
    Positional: [ability: string, model: typeof Model];
  };

  Return: boolean;
}

export default class CanHelper extends Helper<CanSignature> {
  @service abilities!: Services['abilities'];

  compute([ability, model]: CanSignature['Args']['Positional']): boolean {
    return this.abilities.can(ability, model);
  }
}
